module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_8-3b4fe98174de1bccab200d8eadae8d45.jpg";